import { render } from "./WidgetBlock3.vue?vue&type=template&id=5c8f2e98"
import script from "./WidgetBlock3.vue?vue&type=script&lang=js"
export * from "./WidgetBlock3.vue?vue&type=script&lang=js"

import exportComponent from "D:\\working\\MyCi4Vue\\myCi4Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__